import classNames from "classnames";
import ClosetItem from "./ClosetItem";

function ClosetItemsList({ closet, containerClassName }) {
  return (
    <div className={classNames("closet-items-list-container", containerClassName)}>
      {closet.closet_items.map((closetItem) => (
        <ClosetItem
          key={closetItem.id}
          closetState={closet.state}
          closetItem={closetItem}
          closetHasMailboxPickingRequested={!!closet.mail_box_picking_date_requested_at}
        />
      ))}
    </div>
  );
}

export default ClosetItemsList;
